import { ListGuesser } from 'react-admin';
import CartIcon from '@mui/icons-material/RemoveShoppingCart';
import { LeadList } from './LeadList';
import { MdRemoveShoppingCart } from 'react-icons/md';

export default{
  icon: MdRemoveShoppingCart,
  list: LeadList,
};